// Yoast! FAQ section
var faq_container = document.querySelector('.wp-block-yoast-faq-block'),
	faq_section = document.querySelectorAll('.schema-faq-section');

function yoast_faq_accordion() {
	faq_container.classList.add('accordion');
	faq_container.setAttribute('data-accordion', '');
	faq_container.setAttribute('data-allow-all-closed', 'true');

	// for loop on node list for IE11 support
	for (var i = 0; i < faq_section.length; i++) {
		let linkTag = document.createElement('a'),
			title = faq_section[i].querySelector('strong'),
			content = faq_section[i].querySelector('p');

		// make faq_section[i]
		faq_section[i].setAttribute('data-accordion-item', '');
		faq_section[i].classList.add('accordion-item');

		// add class to link
		linkTag.classList.add('accordion-title');

		// make title and wrap in link
		title.parentNode.insertBefore(linkTag, title);
		linkTag.appendChild(title);
		
		// make content
		content.classList.add('accordion-content');
		content.setAttribute('data-tab-content', '');
	}
}

faq_container && faq_section ? yoast_faq_accordion() : '';